// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"19a46213","633":"79f42c10","723":"f5ddf5d5","825":"1b03c55e"}[chunkId] + ".chunk.js";
};